module.exports = __webpack_public_path__ + "img/x-icon-white.5161d8c2.svg";